export default __webpack_public_path__ + "static/media/img_05.5cad5849.jpg";